import React, { Component } from 'react';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import {
  Container,
  Grid,
  Typography
} from '@material-ui/core';
import platformTableauDeBordProjet from '../../../../../media/platform-tableau-de-bord-projet.png';
import platformDocuments from '../../../../../media/platform-documents.png';


const Presentation = ({
  link
}) => {
  return (
    <Container maxWidth="md">
      <Grid container spacing={3}>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Typography variant='h2' components='h2' className="title">
            Présentation
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Slide bottom>
            <img src={platformTableauDeBordProjet} alt="Tableau de bord projet" style={{ width: '100%', borderRadius: '8px', boxShadow: '0 10px 40px rgba(0,0,0,0.15)' }} />
          </Slide>
        </Grid>
        <Grid item xs={12}>
          <p className="lead">
            TriDyme permet aux Maîtres d'Ouvrages de disposer d'une Plateforme Centralisée accessibles directement en ligne et permettant de gérer leurs projets de la phase conception à la phase de gestion, exploitation, maintenance en temps réel.
      </p>
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Fade bottom>
            <img src={platformDocuments} alt="Gestion documentaire" style={{ width: '100%', borderRadius: '8px', boxShadow: '0 10px 40px rgba(0,0,0,0.15)' }} />
          </Fade>
        </Grid>
        <Grid item xs={12}>
          <p className="lead">
            Véritable vecteur de communication au sein de votre projet de construction, la plateforme collaborative BIM est l'outil essentiel pour interagir avec la maquette numérique de manière simple.
      </p>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Presentation;
